import { Link, Outlet, useLocation } from "react-router-dom";
import { Header } from "@/components/layout/Header";
import { useSite } from "@/context/SiteContext";
import { SquareLogo, KnotDivider } from "@/components/ornaments";
import { useT } from "@/lib/labels";
import { CustomButtons } from "@/components/CustomContent";
import { NewsletterBox } from "@/components/Newsletter";
import { CookieBanner } from "@/components/CookieBanner";

const Footer = () => {
  const { settings, sections } = useSite();
  const t = useT();
  const { pathname } = useLocation();
  return (
    <footer data-testid="site-footer" className="mt-24 bg-[#1a120c] text-[#eadfc4]">
      <div className="interlace-band" />
      {pathname !== "/" && <div className="max-w-7xl mx-auto px-6 sm:px-8 pt-12"><NewsletterBox variant="footer" /></div>}
      <div className="max-w-7xl mx-auto px-6 sm:px-8 py-14 grid gap-10 md:grid-cols-12">
        <div className="md:col-span-5 flex gap-5 items-start">
          <SquareLogo src={settings.logo_url} size="md" testid="footer-square-logo" />
          <div>
            <p className="font-display text-2xl text-[#e6bb45]">{settings.site_title}</p>
            <p className="italic mt-2 text-[#cbbd9c]">{settings.tagline}</p>
          </div>
        </div>
        <div className="md:col-span-4">
          {t("footer.codex") && <p className="eyebrow !text-[#e6bb45] mb-3">{t("footer.codex")}</p>}
          <ul className="grid grid-cols-2 gap-y-1.5 text-sm">
            {sections.map((s) => <li key={s.id}><Link className="hover:text-[#e6bb45] transition-colors" to={`/section/${s.slug}`}>{s.name}</Link></li>)}
          </ul>
        </div>
        <div className="md:col-span-3 text-sm space-y-1.5">
          {t("footer.wander") && <p className="eyebrow !text-[#e6bb45] mb-3">{t("footer.wander")}</p>}
          {t("footer.map") && <Link className="block hover:text-[#e6bb45]" to="/map">{t("footer.map")}</Link>}
          {t("footer.all_pages") && <Link className="block hover:text-[#e6bb45]" to="/codex">{t("footer.all_pages")}</Link>}
          <CustomButtons place="footer" className="flex items-center gap-1 hover:text-[#e6bb45]" />
        </div>
      </div>
      <div className="max-w-7xl mx-auto px-6 pb-8">
        <KnotDivider className="mb-4 opacity-70" />
        {settings.legal_enabled && (
          <nav data-testid="footer-legal-links" className="flex flex-wrap justify-center gap-x-6 gap-y-1 mb-3 text-xs font-heading">
            {[["privacy", "Privacy Notice"], ["terms", "Terms of Use"], ["contributor", "Contributor Agreement"]].map(([k, l]) => <Link key={k} to={`/legal/${k}`} data-testid={`footer-legal-${k}`} className="hover:text-[#e6bb45]">{l}</Link>)}
          </nav>
        )}
        <p className="text-center text-xs tracking-widest text-[#a8987a]">{settings.footer_text}</p>
      </div>
    </footer>
  );
};

export default function PublicLayout() {
  return (
    <div className="min-h-screen flex flex-col">
      <Header />
      <main className="flex-1"><Outlet /></main>
      <Footer />
      <CookieBanner />
    </div>
  );
}
